<div class="input-group-custom">
    <div class="custom-date-wrapper">
        <mat-datepicker-toggle [disabled]="isDisabled" [for]="picker" matSuffix>
            <i matDatepickerToggleIcon class="hgi hgi-stroke hgi-calendar-04"></i>
        </mat-datepicker-toggle>

        <input id="dataConsulta" matInput [matDatepicker]="picker" [matDatepickerFilter]="filterDates"
            [(ngModel)]="dataConsulta" (ngModelChange)="selectedData()"  placeholder="dd/mm/aaaa" readonly
            tabindex="-1" />

        <mat-datepicker #picker></mat-datepicker>
    </div>
</div>